import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  DailySalesReportRequestParams,
  DailySalesReportInitialState
} from "../../../config/tableInterface/interface";
import { postExportReport, getDailySalesReportData } from "src/api/sp";
import { resetStore } from "src/store/actions";
import { getComponentKey } from "src/utils/genericFunctions";

export const fetchDailySalesReportData = createAsyncThunk(
  "viewItems/fetchDailySalesReportData",
  ({ ...payload }: DailySalesReportRequestParams) =>
    getDailySalesReportData(payload)
);

export const postingExportDailySalesReportData = createAsyncThunk(
  "dashboard/postDailySalesData",
  (payload: any) => postExportReport(payload)
);

const initialState: DailySalesReportInitialState = {
  data: null,
  recordsCount: null,
  status: "idle",
  error: null,
  errorCount: 0
};

const DailySalesReportData = createSlice({
  name: "DailySalesReport",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchDailySalesReportData.pending, (state) => {
        state.status = "pending";
        state.errorCount += 1;
      })
      .addCase(fetchDailySalesReportData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        state.errorCount -= 1;
        if (payload?.data?.length > 0) {
          state.data = payload.data.map((data: any) => {
            const netSales = Number(data.netSales.slice(1));
            const deposits = Number(data.deposits.slice(1));
            const operatorVCA = Number(data.operatorVCA.slice(1));
            const coupons = Number(data.coupons.slice(1));
            const grocery = Number(data.grocery.slice(1));
            const frozen = Number(data.frozen.slice(1));
            const gm = Number(data.gm.slice(1));
            const hbc = Number(data.hbc.slice(1));
            const meat = Number(data.meat.slice(1));
            const deli = Number(data.deli.slice(1));
            const bw = Number(data.bw.slice(1));
            const produce = Number(data.produce.slice(1));
            const salesTax = Number(data.salesTax.slice(1));
            const customer = Number(data.customer);
            return {
              ...data,
              netSales,
              deposits,
              coupons,
              grocery,
              frozen,
              gm,
              hbc,
              meat,
              deli,
              bw,
              produce,
              salesTax,
              customer,
              uniqueId: getComponentKey(),
              operatorVCA
            };
          });
          state.recordsCount = payload.recordsCount;
        } else {
          state.data = null;
        }
      })
      .addCase(fetchDailySalesReportData.rejected, (state) => {
        state.status = state.errorCount === 1 ? "error" : "pending";
        state.data = null;
        state.errorCount -= 1;
      })
      .addCase(
        postingExportDailySalesReportData.fulfilled,
        (state, { payload }) => {
          state.status = "idle";
        }
      )
      .addCase(postingExportDailySalesReportData.rejected, (state) => {
        state.status = "error";
      });
  }
});

export default DailySalesReportData.reducer;
